import { render, staticRenderFns } from "./AddBeneficiary.vue?vue&type=template&id=e0dd4308&scoped=true"
import script from "./AddBeneficiary.vue?vue&type=script&lang=js"
export * from "./AddBeneficiary.vue?vue&type=script&lang=js"
import style0 from "./AddBeneficiary.vue?vue&type=style&index=0&id=e0dd4308&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0dd4308",
  null
  
)

export default component.exports